<template>
  <div
    class="aha-clipboard-input"
    :id="`${source}-aha-clipboard-input`"
    v-clipboard="clipboard"
    @click="$emit('copy', clipboard())"
  >
    <span class="aha-clipboard-value">{{ clipboard() }}</span>
    <span class="aha-clipboard-copy-button" :id="`${source}-aha-clipboard-copy-button`">
      <aha-icon
        name="copy"
        v-tooltip="'Copy'"
      />
    </span>
  </div>
</template>

<script>

export default {
  props: {
    clipboard: {
      type: Function,
      default: () => {},
    },
    source: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-clipboard-input {
  @apply flex flex-row justify-between items-center;
  @apply appearance-none cursor-pointer mr-2;
  @apply py-2 pl-2 text-sm rounded border border-secondary-20 w-full;
  @apply focus:bg-primary-20 focus:border-primary-90 focus:outline-none;
  @apply hover:bg-primary-20 hover:border-primary-90;
}
.aha-clipboard-value {
  @apply pr-10 overflow-hidden overflow-ellipsis whitespace-nowrap;
}
.aha-clipboard-copy-button {
  @apply mr-2 text-primary-90 font-bold;
}
</style>
